import i18n from 'i18next';

import { IncomeTypeEnum } from '../enums/IncomeTypeEnum';
import { IncomeTypeOption } from '../types/IncomeTypeOption';

export const incomeTypeOptions: IncomeTypeOption[] = [
  {
    name: i18n.t('incomeType.aidForDependentChildren'),
    value: IncomeTypeEnum.AID_FOR_DEPENDENT_CHILDREN,
  },
  {
    name: i18n.t('incomeType.childSupport'),
    value: IncomeTypeEnum.CHILD_SUPPORT,
  },
  {
    name: i18n.t('incomeType.costOfLivingAllowance'),
    value: IncomeTypeEnum.COST_OF_LIVING_ALLOWANCE,
  },
  {
    name: i18n.t('incomeType.disability'),
    value: IncomeTypeEnum.DISABILITY,
  },
  {
    name: i18n.t('incomeType.employment'),
    value: IncomeTypeEnum.EMPLOYMENT,
  },
  {
    name: i18n.t('incomeType.militaryBasicAllowanceForSubsistence'),
    value: IncomeTypeEnum.MILITARY_BASIC_ALLOWANCE_FOR_SUBSISTENCE,
  },
  {
    name: i18n.t('incomeType.municipalBondInterest'),
    value: IncomeTypeEnum.MUNICIPAL_BOND_INTEREST,
  },
  {
    name: i18n.t('incomeType.nonTaxableSources'),
    value: IncomeTypeEnum.NON_TAXABLE_SOURCES,
  },
  {
    name: i18n.t('incomeType.other'),
    value: IncomeTypeEnum.OTHER,
  },
  {
    name: i18n.t('incomeType.publicAssistance'),
    value: IncomeTypeEnum.PUBLIC_ASSISTANCE,
  },
  {
    name: i18n.t('incomeType.rentalIncome'),
    value: IncomeTypeEnum.RENTAL_INCOME,
  },
  {
    name: i18n.t('incomeType.secondaryEmployment'),
    value: IncomeTypeEnum.SECONDARY_EMPLOYMENT,
  },
  {
    name: i18n.t('incomeType.socialSecurity'),
    value: IncomeTypeEnum.SOCIAL_SECURITY,
  },
  {
    name: i18n.t('incomeType.supplementalSecurityIncome'),
    value: IncomeTypeEnum.SUPPLEMENTAL_SECURITY_INCOME,
  },
  {
    name: i18n.t('incomeType.unknown'),
    value: IncomeTypeEnum.UNKNOWN,
  },
  {
    name: i18n.t('incomeType.workmansCompensation'),
    value: IncomeTypeEnum.WORKMANS_COMPENSATION,
  },
];
